export default "__VITE_ASSET__DdS7gThK__"